import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/trading/overview.md?raw';

const TradingOverview: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default TradingOverview;
